import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';

import { closeModal } from '../../actions/modalAction';
import CompanySearch from '../companys/CompanySearch';
//import * as actions from '../../actions/companysAction';
const actions = { closeModal };

class SearchCompanyiesModal extends Component {
  render() {
    return (
      <Modal size="small" open={true} onClose={this.props.closeModal}>
        
        <Modal.Content className='border'>
          <Modal.Description>
            <CompanySearch />
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(SearchCompanyiesModal);
